import TextLayout from "../../components/layouts/TextLayout";
import { contentTermsOfUse } from "./_content";

export default function TermsOfUsePage() {
  return (
    <TextLayout
      title="Terms of Use"
      lastUpdated="10 August 2025"
    >
      {contentTermsOfUse}
    </TextLayout>
  );
}
